<template>
    <main class="reports" v-sticky>
        <div class="page-header">
            <h1 class="page-header__title">Moje zgłoszenia</h1>
        </div>

        <div class="reports__wrapper">
            <ThreadList
                @loadCase="loadCase($event)"
                :medical-cases="medicalReports"
                :key="threadListKey"
                :current-report="currentReport"
                :latest-opened="latestOpenedReportId"
            />

            <div v-if="!currentReport" class="reports__not-selected">
                <h2>Wybierz zgłoszenie aby przejść do wiadomości</h2>
            </div>

            <Thread
                v-else
                @updateThreadList="onUpdateThreadList"
                :current-report="currentReport"
            />

        </div>
    </main>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

import ThreadList from "@/components/messages/threads/ThreadList";
import Thread from "@/components/messages/Thread";

export default {
    name: "Reports",
    components: {
        ThreadList,
        Thread,
    },
    data() {
        return {
            medicalReports: [],
            threadListKey: 0,
            latestOpenedReportId: "",
            currentReport: "",
        };
    },
    computed: mapGetters({
        token: "getToken",
        userData: "getUserData",
        headers: "getSecuredRequestHeader",
        reportList: "getReportList",
    }),
    methods: {
        loadCase(id) {
            this.currentReport = this.currentReport !== id ? id : "";
        },

        onUpdateThreadList(data) {
            this.threadListKey++;

            if (Object.hasOwnProperty.call(data, "urgent")) {
                this.medicalReports = this.medicalReports.map((item) => {
                    if (item.id === data.id) item.urgent = data.urgent;
                    return item;
                });
            }

            if (Object.hasOwnProperty.call(data, "read")) {
                this.medicalReports = this.medicalReports.map((item) => {
                    if (item.id === data.id) item.read.unreadContent.you = false;
                    return item;
                });
            }

        }
    },
    beforeMount() {
        axios
            .get(`${process.env.VUE_APP_API_URL}/medical-report/`, { headers: this.headers })
            .then((response) => {
                const itemsNew  = response.data.filter(item => item.state === 'new');
                const itemsAcknowledged = response.data.filter(item => item.state === 'acknowledged');
                const itemsOngoing = response.data.filter(item => item.state === 'ongoing');
                const itemsResolved = response.data.filter(item => item.state === 'resolved');

                this.medicalReports = [
                ...itemsNew,
                ...itemsAcknowledged,
                ...itemsOngoing,
                ...itemsResolved,
                ];
            });
        this.latestOpenedReportId = this.reportList.latestOpenedReportId;
    },
};
</script>

<style lang="scss">
.reports {
    width: 100%;
    height: 100%;
    background: #fff;
    z-index: 999;
    &.fixed {
        position: fixed;
    }
    &__wrapper {
        display: flex;
        min-height: 100%;
    }
    &__content {
        flex: 1;
        display: flex;
        max-height: calc(100vh - 70px);
        > * {
            flex: 1;
        }
    }
    &__not-selected {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        margin: 50px;
    }
}

</style>
